import { Box, Button, Center, SimpleGrid, Stack, Text, useMantineColorScheme } from "@mantine/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { TextSerif } from "@/components/elements";
import { IconPlus } from "@/components/icons";

interface Props {
  onAddCar: (() => void) | undefined;
}

const CarsTableEmptyState: FC<Props> = ({ onAddCar }) => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Box pos="relative" h={400}>
      <SimpleGrid
        cols={{ base: 1, xs: 2, sm: 2, md: 4 }}
        spacing="xl"
        p="lg"
        style={{
          opacity: isDark ? 0.3 : 0.5,
        }}
      >
        {Array.from({ length: 8 }).map((_, index) => (
          <Stack key={`placeholder-car-${index}`} gap={6} w="100%" miw={220}>
            <Box
              w="100%"
              h={120}
              bdrs="md"
              style={{
                backgroundColor: isDark ? "#333333" : "#EFEFEF",
              }}
            />
            <Box
              w="100%"
              h={12}
              bdrs="sm"
              style={{
                backgroundColor: isDark ? "#333333" : "#EFEFEF",
              }}
            />
            <Box
              w="50%"
              h={8}
              bdrs="sm"
              style={{
                backgroundColor: isDark ? "#333333" : "#EFEFEF",
              }}
            />
          </Stack>
        ))}
      </SimpleGrid>

      <Center pos="absolute" inset={0}>
        <Stack gap="md" ta="center">
          <Stack gap="sm">
            <Text fz="h3">{t("garage.yourGarage")}</Text>
            <TextSerif fz="sm" c={isDark ? "#999999" : "#6A6A84"}>
              {t("garage.noCarsYet")}
            </TextSerif>
          </Stack>

          {onAddCar && (
            <Button
              variant="filled"
              onClick={onAddCar}
              aria-label={t("dashboard.cars.create_button")}
              leftSection={<IconPlus />}
            >
              {t("dashboard.cars.create_button")}
            </Button>
          )}
        </Stack>
      </Center>
    </Box>
  );
};

export default CarsTableEmptyState;
